"use client";
import * as e from "react";
import { N as o } from "./noop-CMWc2wUO.mjs";
const r = /* @__PURE__ */ e.createContext({
  formRef: {
    current: {
      fields: /* @__PURE__ */ new Map()
    }
  },
  errors: {},
  clearErrors: o
});
process.env.NODE_ENV !== "production" && (r.displayName = "FormContext");
function n() {
  return e.useContext(r);
}
export {
  r as F,
  n as u
};
